import { render, staticRenderFns } from "./TaskLeftSkeleton.vue?vue&type=template&id=0ebb0466&scoped=true&"
import script from "./TaskLeftSkeleton.vue?vue&type=script&lang=js&"
export * from "./TaskLeftSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebb0466",
  null
  
)

export default component.exports